<!--
 * @Author: 曹捷
 * @Date: 2022-01-08 17:34:48
 * @LastEditors: 曹捷
 * @LastEditTime: 2022-01-10 09:58:28
 * @Description: fileContent
-->
<template>
  <div class="charts" ref="chartContainer"></div>
</template>

<script>
import { onMounted, toRefs, reactive } from 'vue'
import dayjs from 'dayjs'
export default {
  setup () {
    let _data = reactive({
      chartContainer: null
    })
    let _methods = {
      initChart () {
        const { Line } = G2Plot;
        let data = [
          { date: '12-01', collect: 8793, name: '采集量' },
          { date: '12-02', collect: 7831, name: '采集量' },
          { date: '12-03', collect: 10231, name: '采集量' },
          { date: '12-04', collect: 9331, name: '采集量' },
          { date: '12-05', collect: 11331, name: '采集量' },
          { date: '12-06', collect: 12076, name: '采集量' },
          { date: '12-06', collect: 13876, name: '采集量' },
        ]
        for (let i = 0; i < 7; i++) {
          data[i].date = dayjs().subtract(7 - i, 'd').format('MM/DD')
        }
        const linePlot = new Line(_data.chartContainer, {
          data,
          xField: 'date',
          yField: 'collect',
          seriesField: 'name',
          padding: [30, 40, 30, 60],
          legend: {
            position: 'top',
          },
          // smooth: true,
          // 配置折线趋势填充
          area: {
            style: {
              fillOpacity: 0.15,
            },
          },
          animation: {
            appear: {
              animation: 'wave-in',
              duration: 3000,
            },
          },
          lineStyle: {
            lineWidth: 3
          },
          yAxis: {
            grid: {
              line: {
                style: {
                  stroke: '#6C7C72',
                }
              }
            }
          },
          xAxis: {
            grid: {
              line: {
                style: {
                  stroke: '#6C7C72',
                }
              }
            }
          },
          color: ['#1DB954'],
        });

        linePlot.render();
      }
    }
    onMounted(() => {
      _methods.initChart()
    })
    return {
      ...toRefs(_data),
      ..._methods
    }
  }
}
</script>

<style lang="less">
.charts {
  width: 100%;
  height: 100%;
}
</style>